// Featured Competitions
export const FEATURED_COMPETITION_BG_COLOUR = {
  "navigation-orange": "bg-[#FF8200]",
  "navigation-blue": "bg-[#6679B3]",
  "navigation-purple": "bg-[#50286F]",
  "navigation-turquoise": "bg-[#32BAB5]",
  "navigation-red": "bg-[#AE1F25]",
  "navigation-white": "bg-[#FFFFFF]",
  "navigation-azure": "bg-[#3772FF]",
  "navigation-green": "bg-[#128910]",
  "navigation-dark-fuchsia": "bg-[#9E0057]",
  "navigation-dark-blue": "bg-[#24339F]",
};

export const FEATURED_COMPETITION_ENDS_TEXT_COLOUR = {
  "navigation-orange": "text-[#663400]",
  "navigation-blue": "text-[#3B4A77]",
  "navigation-purple": "text-[#50286F]",
  "navigation-turquoise": "text-[#1C6966]",
  "navigation-red": "text-[#82171C]",
  "navigation-white": "text-[#6279B8]",
  "navigation-azure": "text-[#3772FF]",
  "navigation-green": "text-[#128910]",
  "navigation-dark-fuchsia": "text-[#9E0057]",
  "navigation-dark-blue": "text-[#24339F]",
};

export const FEATURED_COMPETITION_ENDS_TEXT_BORDER_COLOUR = {
  "navigation-orange": "border-[#FFD8B0]",
  "navigation-blue": "border-[#D0D5E7]",
  "navigation-purple": "border-[#C9BCD2]",
  "navigation-turquoise": "border-[#D0D5E7]",
  "navigation-red": "border-[#D0D5E7]",
  "navigation-white": "border-[#6279B8]",
  "navigation-azure": "border-[#D2DFFF]",
  "navigation-green": "border-[#D0D5E7]",
  "navigation-dark-fuchsia": "border-[#D0D5E7]",
  "navigation-dark-blue": "border-[#D0D5E7]",
};

export const FEATURED_COMPETITION_ENDS_TEXT_BG_COLOUR = {
  "navigation-orange": "bg-[#FFF3E6]",
  "navigation-blue": "bg-[#F0F2F7]",
  "navigation-purple": "bg-[#EEEAF1]",
  "navigation-turquoise": "bg-[#F0F2F7]",
  "navigation-red": "bg-[#F0F2F7]",
  "navigation-white": "bg-[#F0F2F7]",
  "navigation-azure": "bg-[#F0F2F7]",
  "navigation-green": "bg-[#F0F2F7]",
  "navigation-dark-fuchsia": "bg-[#F0F2F7]",
  "navigation-dark-blue": "bg-[#F0F2F7]",
};

// Rewards Competitions
export const REWARD_COMPETITION_NAME_TEXT_COLOUR = {
  "navigation-azure": "text-[#3772ff]",
  "navigation-red-on-white": "text-[#C42E35]",
  "navigation-red": "text-[#C42E35]",
};

export const REWARD_COMPETITION_CTA_BG_COLOR = {
  "navigation-azure": "bg-[#3772ff]",
  "navigation-red-on-white": "bg-[#ae1f25]",
  "navigation-red": "bg-[#ae1f25]",
};

// Competition header in shopping cart popover
export const CART_COMPETITION_HEADER_BG_COLOUR = {
  "navigation-orange": "bg-[#FFF3E6]",
  "navigation-blue": "bg-[#C7CCE1]",
  "navigation-purple": "bg-[#F6EAFA]",
  "navigation-turquoise": "bg-[#D4E7E6]",
  "navigation-red": "bg-[#FAEBEB]",
  "navigation-white": "bg-[#C7CCE1]",
  "navigation-azure": "bg-[#FFFFFF]",
  "navigation-green": "bg-[#EAFDEA]",
  "navigation-dark-fuchsia": "bg-[#FFECF7]",
  "navigation-dark-blue": "bg-[#EEF0FB]",
};

export const CART_COMPETITION_HEADER_TEXT_COLOUR = {
  "navigation-orange": "text-[#ff8200]",
  "navigation-blue": "text-[#6878b3]",
  "navigation-purple": "text-[#562373]",
  "navigation-turquoise": "text-[#32bab5]",
  "navigation-red": "text-[#ae1f25]",
  "navigation-white": "text-[#6878b3]",
  "navigation-azure": "text-[#3772ff]",
  "navigation-green": "text-[#128910]",
  "navigation-dark-fuchsia": "text-[#9E0057]",
  "navigation-dark-blue": "text-[#24339F]",
};

export const FEATURED_COMPETITION_HOVER_COLOUR = {
  "navigation-orange": "bg-[#FF6A00]",
  "navigation-blue": "bg-[#465A96]",
  "navigation-purple": "bg-[#3D1952]",
  "navigation-turquoise": "bg-[#258885]",
  "navigation-red": "bg-[#CC3239]",
  "navigation-white": "bg-[#FFFFFF]",
  "navigation-azure": "bg-[#1E60FF]",
  "navigation-green": "bg-[#0F720D]",
  "navigation-dark-fuchsia": "bg-[#850049]",
  "navigation-dark-blue": "bg-[#1F2C8A]",
};

export const MOBILE_NAV_MENUS_ITEMS = [
  { Title: "Winners", Url: "/winners" },
  { Title: "Prize Collections", Url: "/collections/prize-collections" },
  { Title: "Customer Reviews", Url: "/testimonials" },
  { Title: "How to play / FAQs", Url: "/how-to-play" },
  { Title: "Contact Us", Url: "/contact-us" },
];

export const DEFAULT_LOGO = "/assets/images/BotB-win-a-competition.json";
